import type { FaireProductEntity } from "../../entity_types/product";

export const p_vw2fn6fah6: FaireProductEntity = {
  token: "p_vw2fn6fah6",
  type: "product",
  name: "Cloud II™ Sport Headband - Nocturne",
  brandToken: "b_qa8gaqqvwt",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b318a6dc3fa0a4243e7e7539d89cbf8dc8adb919e221cd30cccabc3e9a3696ee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0b7a2120cc8cd67a28a6618f572bf1f39ff31e0ded86199054301e71461c0294.jpeg",
    "https://cdn.faire.com/fastly/7a319befcd80705a5fcc2e4f067a15ae3905c4024ff8f7d49a84c8d6ec449d77.jpeg",
  ],
  priceDollars: 16.5,
  description:
    "The Cloud II Sport Headband is the perfect accessory for all you Cloud II superfans. A simple design with subtle Vitality branding, the Sport Headband is made to keep you comfortable and looking great even during your sweatiest workouts. Based on your feedback, we’ve also made her narrower than our past headband styles so she stays in place even better.\n",
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:45.549Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
